import { useEffect, useState } from 'react'
import { ISocietiesModel } from '../../../interfaces/models/societies.interfaces'

function getLastSentInvoiceDate(society: ISocietiesModel): Date | undefined {
  const { lastInvoiceDate: lastInvoiceDateString } = society
  if (!lastInvoiceDateString) {
    return undefined
  }

  const lastInvoiceDate = new Date(lastInvoiceDateString)
  // In some cases lastInvoiceDate gets set to 2000-01-01 on the backend to force a new invoice
  const defaultPlaceholderDate = new Date('2000-01-01')

  if (
    lastInvoiceDate.getFullYear() === defaultPlaceholderDate.getFullYear() &&
    lastInvoiceDate.getMonth() === defaultPlaceholderDate.getMonth() &&
    lastInvoiceDate.getDate() === defaultPlaceholderDate.getDate()
  ) {
    return undefined
  }

  return lastInvoiceDate
}
export const usePaymentDates = (
  society: ISocietiesModel,
  cost: number | undefined
): {
  nextPaymentDate: Date | null
} => {
  const [nextPaymentDate, setNextPaymentDate] = useState<Date | null>(null)

  useEffect(() => {
    const lastSentInvoiceDate = getLastSentInvoiceDate(society)
    if (lastSentInvoiceDate || society.accountTypeChangeDate) {
      // We have an existing invoice, add 1 year to it.
      if (lastSentInvoiceDate) {
        const _nextPaymentDate = new Date(lastSentInvoiceDate)
        _nextPaymentDate.setFullYear(_nextPaymentDate.getFullYear() + 1)
        setNextPaymentDate(_nextPaymentDate)
      } else if (
        // We don't have an existing invoice and the user did not just upgrade
        cost &&
        !lastSentInvoiceDate &&
        society.accountTypeChangeDate &&
        new Date(society.accountTypeChangeDate) <
          new Date(new Date().setHours(0, 0, 0, 0))
      ) {
        setNextPaymentDate(new Date())
      } else if (society.accountTypeChangeDate) {
        // User have no invoice and no cost.
        const _accountTypeChangeDate = new Date(society.accountTypeChangeDate)
        _accountTypeChangeDate.setFullYear(
          new Date(_accountTypeChangeDate).getFullYear() + 1
        )
        setNextPaymentDate(_accountTypeChangeDate)
      }
    }
  }, [society, cost])

  return {
    nextPaymentDate,
  }
}
